import React, { useState, useEffect, useSelector } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import { GrDocumentVerified } from "react-icons/gr";
import { BsPencilSquare } from "react-icons/bs";
import { optionsBranch } from "../data/branch-data";
import { generateStatus } from "../utils/generateDisplay";
import {
  getCompany,
  getDocumentRequest,
  getInternshipRequest,
  getDocumentReqStudent,
  getInternStudent,
  getInternshipRequest2,
  getInternStudent2,
} from "../api/crud";
import { Box, Button } from "@mui/material";
import ModalView from "./ModalView";
import InternPageReview from "./InternPageReview";
import DrawerView from "./DrawerView";
import FormReview from "./FormReview";
import FormReviewCompleted from "./FormReviewCompleted";
import { pad } from "lodash";

const ProfileDetail = ({ st_id }) => {
  const navigate = useNavigate();
  //const profile = useSelector((state) => state.profileReducer.profile);
  const [isLoading, setIsLoading] = useState(false);
  const [profileDetail, setProfileDetail] = useState(null);
  const [internShipReqAll, setinternShipReq] = useState(null);
  const [isOpenModalForm, setIsOpenModalForm] = useState(false);
  const [isOpenDrawerFormReview, setIsOpenDrawerFormReview] = useState(false);
  const [userInternData, setuserInternData] = useState(null);
  const [onEdit, setOnEdit] = useState(false);

  const getUsername = localStorage.getItem("username");
  
  // ตรวจสอบว่า user เป็นนิสิตหรือ admin
  const isStudent = !isNaN(getUsername); // ถ้ารหัส user เป็นตัวเลข = นิสิต
  const isAdmin = !isStudent; // ถ้าไม่ใช่ตัวเลข = admin/staff
  
  var docReq;

  const onEditClick = () => {
    setOnEdit(!onEdit);
  };

  const fetchInternStudent = async () => {
    try {
      setIsLoading(true);
      const allCompany = await getCompany();
      const internShipReq = await getInternshipRequest();  
      const documentRequest = await getDocumentRequest();
      const documentReqStudent = await getDocumentReqStudent();
      const internStudent = await getInternStudent();

      const ck1 = internShipReq.find(
        (req) => req.st_id == st_id
      );

      const ck2 = internStudent.find(
        (st) => st.id == st_id
      );
   

    if(ck1 || ck2){
      await getInternStudent()
        .then((res) => {
          const list = res.filter((el) => {
            return el.id == st_id;
          });
          

          const listMatchCompany = list.map((item) => {

            const internDetail = internShipReq.find(
              (req) => req.st_id == item.id
            );
          
         
            const docReqs = documentReqStudent
              .filter((e) => e.st_id == st_id)
              .sort((a, b) => b.idm_id - a.idm_id);

            return {
              ...item,
              internDetail: internDetail,
              companyDetail: allCompany.find(
                (cpn) => cpn.id == internDetail?.cp_id
              ),
              documentRequest: docReqs[0],
            };
          });

          setProfileDetail(listMatchCompany[0]);
          // setInternFilterList(listMatchCompany);
        })
        .catch((err) => {
          console.log(err);
        });


    }else{

      const internShipReq2 = await getInternshipRequest2();
     
     
     
      await getInternStudent2()
        .then((res) => {
          const list = res.filter((el) => {
            return el.id == st_id;
          });

          const listMatchCompany = list.map((item) => {

            const internDetail = internShipReq2.find(
              (req) => req.st_id == item.id
            );
          
          
            const docReqs = documentReqStudent
              .filter((e) => e.st_id == st_id)
              .sort((a, b) => b.idm_id - a.idm_id);

            return {
              ...item,
              internDetail: internDetail,
              companyDetail: allCompany.find(
                (cpn) => cpn.id == internDetail?.cp_id
              ),
              documentRequest: docReqs[0],
            };
          });

          setProfileDetail(listMatchCompany[0]);
          // setInternFilterList(listMatchCompany);
        })
        .catch((err) => {
          console.log(err);
        });

      }


    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (st_id) {
      fetchInternStudent();
    }
  }, [st_id]);

  const displayContent = (
    <div className="card mb-3">
      <div className="card-header">
        <h5 className="card-title mb-0">ข้อมูลนิสิต</h5>
      </div>

      <div className="card-body text-center">
        {profileDetail && !isNaN(profileDetail.id) ? (
          <img
            src={`https://reg.buu.ac.th/registrar/getstudentimage.asp?id=${st_id}`}
            width="120px"
          />
        ) : (
          <img src={`./assets/images/user.png`} width="120px" />
        )}
        <h5 className="card-title mb-0">{profileDetail?.name}</h5>
        <div className="text-muted mb-2">
          <span>{profileDetail?.id}</span>
        </div>
      </div>

      <hr className="my-0" />
      <div className="card-body">
        <form action="./update-profile.php" method="post">
          <div className="text-end">
            {onEdit && (
              <button className="btn btn-primary mx-2 btn-sm" type="submit">
                บันทึก
              </button>
            )}
            <BsPencilSquare size="1rem" onClick={onEditClick} role="button" />
          </div>
          <table class="table table-sm my-2">
            <tbody>
              <tr>
                <th>สาขาวิชา</th>
                <td>
                  {
                    optionsBranch?.find((el) => el.value == profileDetail?.b_id)
                      ?.label
                  }
                </td>
              </tr>
              <tr>
                <th>เกรดเฉลี่ยสะสม</th>
                <td>{(+profileDetail?.gpa)?.toFixed(2)}</td>
              </tr>
              <tr>
                <th>Email</th>
                <td>
                  <input
                    readOnly={!onEdit}
                    className={`form-control ps-0 ${
                      !onEdit && "field-editable"
                    }`}
                    name="email"
                    defaultValue={profileDetail?.st_mail}
                    style={{ color: "inherit" }}
                  />
                </td>
              </tr>
              
              <tr>
                <th>เบอร์โทร</th>
                <td>
                  <input
                    readOnly={!onEdit}
                    className={`form-control ps-0 ${
                      !onEdit && "field-editable"
                    }`}
                    name="tel"
                    defaultValue={profileDetail?.st_tel}
                    style={{ color: "inherit" }}
                  />
                </td>
              </tr>
              {isAdmin && (
                <tr>
                  <th>ปีการศึกษาฝึกงาน</th>
                  <td>
                    <input
                      readOnly={!onEdit}
                      className={`form-control ps-0 ${
                        !onEdit && "field-editable"
                      }`}
                      name="school_yrs"
                      defaultValue={profileDetail?.school_yrs}
                      style={{ color: "inherit" }}
                    />
                  </td>
                </tr>
              )}

              <tr>
              
                <th>สถานะ</th>
                <td>
                  <span>
                    {!!profileDetail &&
                      generateStatus(profileDetail?.status_id)}
                  </span>
                  {(!profileDetail ||
                    profileDetail?.status_id == "15" ||
                    profileDetail?.status_id == "14" ||
                    profileDetail?.status_id == "32") && (
                    <Link to="/request-form" className="ms-2">
                      ยื่นความประสงค์ขอฝึกงานใหม่
                    </Link>
                  )}
                </td>
              </tr>

              {profileDetail?.internDetail?.status == 2 && (
                <tr>
                  <th></th>
                  <td>
                    <div
                      className="ms-2 text-secondary"
                      onClick={() => setIsOpenModalForm(true)}
                      type="button"
                    >
                      <GrDocumentVerified /> คำร้องขอฝึกงานที่อนุมัติ
                    </div>
                  </td>
                </tr>
              )}

              {/* {(profileDetail?.status_id == "31" ||
                profileDetail?.status_id == "3") && (
                //profileDetail?.documentRequest?.idm_status == "3"
                //
                <tr>
                  <th></th>
                  <td>
                    <div
                      className="ms-2 text-secondary"
                      onClick={() => setIsOpenDrawerFormReview(true)}
                      type="button"
                    >
                      <GrDocumentVerified /> หนังสือขอความอนุเคราะห์ (เลขที่{" "}
                      {profileDetail?.documentRequest?.idm_id})
                    </div>
                  </td>
                </tr>
              )} */}
              <tr>
                <th></th>
                <td>
                  <Link to={`/activity-log?st_id=${st_id}`}>
                    บันทึกการฝึกอบรม
                  </Link>
                </td>
              </tr>

              {/* <tr>
                <th></th>
                <td>
                  <Link
                    to={`/intern-manual?req_id=${profileDetail?.internDetail?.req_id}`}
                    target="_blank"
                  >
                    แจ้งรายละเอียดการปฏิบัติงาน
                  </Link>
                </td>
              </tr> */}
            </tbody>
          </table>
          <input className="d-none" value={profileDetail?.id} name="st_id" />
          <input className="d-none" value={getUsername} name="user" />
        </form>
      </div>
    </div>
  );

  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "400px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        displayContent
      )}

      <ModalView
        isModaOpen={isOpenModalForm}
        setIsModalOpen={setIsOpenModalForm}
        title="รายละเอียดคำร้องขอฝึกงาน"
        
        

      
      >
        <InternPageReview data={profileDetail} readOnly />
      </ModalView>

      <DrawerView
        isOpen={isOpenDrawerFormReview}
        setIsOpen={setIsOpenDrawerFormReview}
        content={""}
        // <FormReviewCompleted data={profileDetail?.documentRequest}   />
        // <FormReviewC companyId={profileDetail?.companyDetail?.id} readOnly />
      />
    </>
  );
};

export default ProfileDetail;
